import React from 'react';
import Select from 'react-select';
import {
  ReactSelectHelper,
  ReactSelectOnChangeCallback
} from '../../../../../../lib/components/select/base/react-select-types';
import {MQLeftSideType} from '../../models';

type LeftSideType = MQLeftSideType;

type LeftTypeSelectProps = {
  value: LeftSideType;
  onChange: (leftSide: LeftSideType) => void;
};

type OptionType = { value: LeftSideType, label: string };

const options: readonly OptionType[] = [
  {value: 'text', label: 'Text'},
  {value: 'image', label: 'Image'}
];


export class MQLeftTypeSelector extends React.Component<LeftTypeSelectProps> {
  constructor(props: Readonly<LeftTypeSelectProps>) {
    super(props);
    this.handleChange = ReactSelectHelper.mappingSingle(
      'MatchingQuestionLeftType',
      (option: OptionType) => option.value,
      props.onChange);
  }

  handleChange: ReactSelectOnChangeCallback<OptionType>;

  render() {
    const value = options.find(x => x.value === this.props.value)!;

    return (
      <Select<OptionType> options={options}
                          value={value}
                          onChange={this.handleChange}
                          isClearable={false}>
      </Select>);
  }

}
